const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const StudentLink = require("./StudentLink");
const Tooltip = require("./Tooltip");
const {Icon} = require("./Icon");
const Z = require("../../../shared/ZIndex");
const tooltipText = require("../util/CopyTable").tooltipText;
const Sounds = require("../util/Sounds");
const AssetsUtil = require("../util/AssetsUtil");

const clsx = require("clsx");
const styles = require("./styles/IconButton.css");

module.exports = createReactClass({
	displayName: "IconButton",

	propTypes: {
		iconEl: PT.element,
		iconName: PT.string,
		iconImgPath: PT.string,
		chapterNumber: PT.number,
		gradeNumber: PT.number,
		iconClass: PT.string,
		tooltipClass: PT.string,
		tooltipSize: PT.oneOf(["small", "medium", "medium-wrap", "large"]),
		linkTo: PT.string,
		isExternal: PT.bool,
		handleClick: PT.func,
		isSelected: PT.bool,
		underlineClass: PT.string,
		clickSound: PT.oneOfType([PT.string, PT.array]),
		masked: PT.bool,
		demoTutorialHighlight: PT.bool,
		hidden: PT.bool,
		useLinkStyle: PT.bool,
		fadeIn: PT.bool,
		buttonEffects: PT.bool, // cursor, click animation, shadow
		ariaLabel: PT.string,
	},

	getDefaultProps: function() {
		return {
			buttonEffects: true,
		};
	},

	onClick: function(evt) {
		if (this.props.clickSound) {
			if (_.isArray(this.props.clickSound)) {
				_.each(this.props.clickSound, soundName => {
					Sounds.playSound(soundName);
				});
			} else {
				Sounds.playSound(this.props.clickSound);
			}
		}
		if (this.props.handleClick) {
			this.props.handleClick(evt, this.props.iconName);
		}
	},

	render: function() {
		const {
			isSelected,
			iconEl,
			iconImgPath,
			iconName,
			chapterNumber,
			gradeNumber,
			fadeIn,
			masked,
			demoTutorialHighlight,
			hidden,
			linkTo,
			isExternal,
			useLinkStyle,
			tooltipClass,
			tooltipSize,
			buttonEffects,
			children,
			ariaLabel,
		} = this.props;
		// Selected icons get underline and also get smaller
		const underlineClass = this.props.underlineClass || styles.underline;

		const underline = isSelected ? (
			<img
				className={underlineClass}
				src={AssetsUtil.getGeneralIcon("underline-selected")}
			/>
		) : null;

		let icon = null;
		if (iconEl) {
			icon = iconEl;
		} else {
			icon = (
				<Icon
					iconName={iconName}
					iconImgPath={iconImgPath}
					chapterNumber={chapterNumber}
					gradeNumber={gradeNumber}
				/>
			);
		}

		const renderIcon = (
			<div
				onClick={this.onClick}
				className={clsx(
					styles.icon,
					isSelected ? styles.selected : styles.unselected,
					{
						[styles.fadeIn]: fadeIn,
						[styles.masked]: masked,
						[styles.buttonEffects]: buttonEffects,
					}
				)}
				ref={i => (this.icon = i)}
				aria-label={ariaLabel}
			>
				{icon}
				{underline}
				{children}
			</div>
		);

		let styleOverride = {zIndex: Z.iconButton};

		if (demoTutorialHighlight) {
			styleOverride = _.extend(styleOverride, {
				zIndex: Z.aboveDemoBar,
			});

			if (iconName === "videoPlayer") {
				styleOverride = _.extend(styleOverride, {
					left: "68%",
					width: "3.48rem",
					height: "3.55rem",
					top: "9.5414%",
				});
			} else if (iconName === "bookmark") {
				styleOverride = _.extend(styleOverride, {
					left: "72.6%",
					width: "3.48rem",
					height: "3.55rem",
					top: "9.5414%",
				});
			}
		}

		if (hidden) {
			styleOverride = _.extend(styleOverride, {
				visibility: "hidden",
			});
		}

		if (linkTo) {
			const linkClass = this.props.iconClass + " " + styles.link;

			if (masked) {
				return (
					<div className={tooltipClass}>
						<div className={linkClass}>{renderIcon}</div>
					</div>
				);
			}
			return (
				<Tooltip
					tooltipText={tooltipText[iconName + "Icon"]}
					size={tooltipSize || "small"}
					tooltipStyle={{zIndex: Z.tooltipIcon}}
					className={tooltipClass}
					hidden={hidden || false}
				>
					<StudentLink
						to={linkTo}
						isExternal={isExternal}
						isNewTab={isExternal}
						className={linkClass}
						style={styleOverride}
						useWonkyCursor={true}
					>
						{renderIcon}
					</StudentLink>
				</Tooltip>
			);
		} else if (useLinkStyle) {
			return (
				<div className={tooltipClass}>
					<div className={this.props.iconClass}>{renderIcon}</div>
				</div>
			);
		} else {
			return (
				<div className={this.props.iconClass} style={styleOverride}>
					{renderIcon}
				</div>
			);
		}
	},
});
